var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97934 6.45902L10.7397 7.17934M12.1685 8.53292L13.0792 9.39573M14.5414 10.781L15.4521 11.6438M16.8809 12.9974L17.6412 13.7177M12.0849 3.68854L2.7268 12.5541C1.75773 13.4722 1.75773 14.9606 2.7268 15.8787L3.31168 16.4328C4.28074 15.5147 5.8519 15.5147 6.82096 16.4328C7.79002 17.3508 7.79002 18.8393 6.82096 19.7574L7.40584 20.3115C8.3749 21.2295 9.94606 21.2295 10.9151 20.3115L20.2732 11.4459C21.2423 10.5278 21.2423 9.03938 20.2732 8.12132L19.6883 7.56722C18.7193 8.48528 17.1481 8.48528 16.179 7.56722C15.21 6.64917 15.21 5.1607 16.179 4.24264L15.5942 3.68854C14.6251 2.77049 13.0539 2.77049 12.0849 3.68854Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/invitation.ec949f94830e4e6f3b2d2520ab5122c2.svg";
export { ForwardRef as ReactComponent };